<div class="edit-page-root-container voucher-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()" [disabled]="!isReady">SAVE</button>
                }

            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" appCodeInput
                                        [readonly]="voucherInfo.id!==undefined && voucherInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">
                                        code should be entered
                                    </mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">
                                        Maximum length is 10.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" maxlength="100">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">
                                        name should be entered
                                    </mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">
                                        Maximum length is 50.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" maxlength="500" rows="3"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">
                                Maximum length is 500.
                            </mat-error>
                        </mat-form-field>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="voucher-type">
                                    <mat-label>Voucher Type</mat-label>
                                    <mat-select formControlName="voucher_type">
                                        <mat-option [value]="1">
                                            St. Pierre's
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="editForm.controls['voucher_type'].hasError('required')">
                                        type should be selected
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="voucher-value">
                                    <mat-label>Voucher Value</mat-label>
                                    <input matInput formControlName="value" type="number" min="0" step="0.01">
                                    <mat-error *ngIf="editForm.controls['value'].hasError('required')">
                                        value should be entered
                                    </mat-error>
                                    <mat-error *ngIf="editForm.controls['value'].hasError('min')">
                                        Value must be greater than or equal to 0
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right checkbox-container">
                                <mat-checkbox formControlName="is_change_payable" class="voucher-checkbox">
                                    Balance In Cash
                                </mat-checkbox>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="account-code">
                                    <mat-label>Account Code</mat-label>
                                    <input matInput formControlName="account_code" maxlength="50">
                                    <mat-error *ngIf="editForm.controls['account_code'].hasError('required')">
                                        Account code should be entered
                                    </mat-error>
                                    <mat-error *ngIf="editForm.controls['account_code'].hasError('maxlength')">
                                        Maximum length is 50.
                                    </mat-error>
                                </mat-form-field>
                            </div>


                        </div>





                    </div>
                </div>
            </form>
        </div>
    </div>
</div>